import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { OAuthService } from "angular-oauth2-oidc";

@Injectable()
export class SessionIdInterceptor implements HttpInterceptor {
	constructor(private oauthService: OAuthService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const existingSessionId = localStorage.getItem("session_id");
		const isRootUrl = req.url.includes(environment.urlRoot);
		const hasValidAccessToken = this.oauthService.hasValidAccessToken();

		// Clear session_id if token is expired
		if (!hasValidAccessToken) {
			localStorage.removeItem("session_id");
		}

		if (existingSessionId && isRootUrl && hasValidAccessToken) {
			const cloned = req.clone({
				setHeaders: {
					"X-Session-ID": existingSessionId,
				},
			});
			return next.handle(cloned);
		}

		return next.handle(req);
	}
}
